/**
 * PWA durum şeridi — ÇEVRİMDIŞI ve YENİ SÜRÜM uyarıları.
 *
 * ═══════════════════════════════════════════════════════════════════════════
 * ÇEVRİMDIŞIYKEN EKRANDA DURAN VERİ ESKİDİR — VE BUNU SÖYLEMEK ZORUNDAYIZ.
 *
 * Service worker kabuğu (JS/CSS) önbellekten servis ediyor, yani uygulama
 * çevrimdışı da AÇILIYOR. Ama API istekleri asla önbellekten gelmiyor
 * (`public/sw.js` kural 1): ekranda ne varsa bağlantı kopmadan önce
 * gelendir. Uyarı olmasaydı kullanıcı üç saat önceki bir tank seviyesine
 * bakıp "şu an böyle" diye karar verirdi.
 * ═══════════════════════════════════════════════════════════════════════════
 */
import { useEffect, useState } from 'react';

import { Button } from '../design/Button.tsx';
import { swKaydet } from './sw-kayit.ts';

export function PwaDurumu(): React.JSX.Element | null {
  const [cevrimdisi, setCevrimdisi] = useState(
    // `navigator.onLine` kesin değil (ağ var, internet yok olabilir) ama
    // `false` dediğinde HER ZAMAN haklıdır — yalnız o yönde güveniyoruz.
    typeof navigator === 'undefined' ? false : !navigator.onLine,
  );
  const [guncelle, setGuncelle] = useState<(() => void) | null>(null);

  useEffect(() => {
    const cevrimici = () => setCevrimdisi(false);
    const kopuk = () => setCevrimdisi(true);
    window.addEventListener('online', cevrimici);
    window.addEventListener('offline', kopuk);
    return () => {
      window.removeEventListener('online', cevrimici);
      window.removeEventListener('offline', kopuk);
    };
  }, []);

  useEffect(() => {
    swKaydet((uygula) => {
      setGuncelle(() => uygula);
    });
  }, []);

  if (!cevrimdisi && guncelle === null) return null;

  return (
    <div className="flex flex-col">
      {cevrimdisi && (
        <p role="status" className="bg-warn-bg px-4 py-2 text-center text-sm text-warn">
          Çevrimdışısınız — ekrandaki veriler bağlantı kopmadan önceki hâlidir.
        </p>
      )}
      {guncelle !== null && (
        <div className="flex flex-wrap items-center justify-center gap-3 bg-brand-50 px-4 py-2 text-sm text-brand-700">
          <span>Yeni sürüm hazır.</span>
          {/*
           * Devralma KULLANICI basınca: form doldururken sayfanın altından
           * kod değişmesin.
           */}
          <Button size="sm" variant="secondary" onClick={guncelle}>
            Şimdi güncelle
          </Button>
        </div>
      )}
    </div>
  );
}
